import React, { useState, useEffect } from 'react';
import API from '../Api';
import SubPageHeader from '../../components/common/SubPageHeader';

// Image Import
import workshopImage1 from '../../assets/images/VinayNamaskarcopy.jpg'; 

const Workshop = () => {
  
  const [workshops, setWorkshops] = useState([]);

  const resolveImageUrl = (imgData) => {
    if (!imgData) return workshopImage1; 
    if (imgData.startsWith('http')) return imgData; 
    
    
    return imgData.startsWith('/') 
        ? `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${imgData}` 
        : `${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/${imgData}`;
};

  useEffect(() => {
    const fetchWorkshops = async () => {
      const defaultWorkshop = [{
        category: "Rural Empowerment",
        title: "ENTREPRENEURSHIP FOR RURAL YOUTH",
        desc1: "A specialized session titled 'How to be an Entrepreneur?' was successfully conducted at the RAMDHAM center...",
        desc2: "We were honored to have Mr. Suresh Umap, the Regional Director of MCED, as our guest speaker...",
        img: workshopImage1
      }];

      try {
        const res = await API.get('get-content/Workshop/');
        const data = res.data;
        const temp = [];
        let i = 1;
        while (data[`ws${i}_title`]) {
          temp.push({
            category: data[`ws${i}_category`] || "Workshop",
            title: data[`ws${i}_title`],
            desc1: data[`ws${i}_desc1`],
            desc2: data[`ws${i}_desc2`],
            img: data[`ws${i}_img`]
          });
          i++;
        }
        setWorkshops(temp.length > 0 ? temp : defaultWorkshop);
      } catch (err) {
        setWorkshops(defaultWorkshop);
      }
    };
    fetchWorkshops();
  }, []);
  return (
    <div className="min-h-screen bg-gray-50 overflow-x-hidden">
      {/* 1. Header with normal (non-italic) font */}
      <SubPageHeader title="WORKSHOPS" />

      <div className="relative">
        {/* Decorative Background Blobs */}
        <div className="absolute top-20 left-0 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-40 right-0 w-72 h-72 bg-green-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

        <section className="py-10 md:py-16 lg:py-24 relative z-10">
          <div className="container mx-auto px-4 sm:px-6 md:px-12 lg:px-20">
            
            {/* Main Content Card */}
            {workshops.map((ws, index) => (
              <div
                key={index}
                className="
                  bg-white
                  rounded-[1.5rem]
                  md:rounded-[3rem]
                  shadow-2xl
                  border-[4px]
                  md:border-[12px]
                  border-[#003366]/5
                  p-5
                  sm:p-6
                  md:p-10
                  lg:p-16
                  mb-8
                  md:mb-16
                "
              >
                <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
                  
                  {/* Content Side */}
                  <div className="flex-1 space-y-8">
                    <div className="
                          inline-block
                          px-3
                          md:px-4
                          py-1
                          rounded-full
                          bg-blue-100
                          text-[#003366]
                          text-xs
                          md:text-sm
                          font-bold
                          tracking-wider
                          uppercase
                          "
                    >
                      {ws.category}
                    </div>
                    
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-[#003366] leading-tight">
                      {ws.title}
                    </h2>
                    
                    <div className="
                        space-y-4
                        text-sm
                        sm:text-base
                        md:text-lg
                        text-gray-700
                        leading-relaxed
                        text-justify
                        "
                    >
                      <p>{ws.desc1}</p>
                      <p>{ws.desc2}</p>
                    </div>

                    <div className="w-20 h-1 bg-[#54a50f] rounded-full"></div>
                  </div>

                  {/* Image Side */}
                  <div className="flex-1 w-full group">
                    <div className="relative"> 
                      <div className="absolute -inset-4 bg-gradient-to-tr from-[#003366] to-[#54a50f] rounded-[2rem] blur opacity-20 group-hover:opacity-40 transition duration-500"></div>
                      <div className="relative overflow-hidden rounded-[2rem] shadow-2xl bg-white p-3 transition duration-500">
                        <img
                          src={resolveImageUrl(ws.img)}
                          alt={ws.title}
                          className="
                            w-full
                            h-auto
                            md:h-[400px]
                            object-contain
                            md:object-cover
                            rounded-[1.5rem]
                            cursor-pointer
                            transition-transform
                            duration-700
                            hover:scale-105
                          "
                          onError={(e) => {
                            e.target.src = workshopImage1;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Call to Action Footer  */}
                {index === workshops.length - 1 && (
                  <div className="mt-10 md:mt-20 pt-6 md:pt-12 border-t border-gray-100 text-center space-y-4 md:space-y-6">
                    <p className="
                      text-[#003366]
                      font-bold
                      text-base
                      sm:text-lg
                      md:text-xl
                      uppercase
                      tracking-wide
                      "
                    >
                      BE THE CHANGE IN YOUR COMMUNITY!
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Workshop;